import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { CalendarView } from 'angular-calendar';
import ICalendar from '../../../_interfaces/ICalendar';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';
import { SessionService } from '../../../_services/session/session.service';
import { BaseComponent } from '../../base/base.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-selector-calendar-period',
  imports: [
    CommonModule,
    ButtonModule,
    PopoverModule,
    DatePickerModule,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: './selector-calendar-period.component.html',
  styleUrl: './selector-calendar-period.component.scss',
})
export class SelectorCalendarPeriodComponent
  extends BaseComponent
  implements OnInit, OnChanges
{
  @Input('view') view: CalendarView = CalendarView.Week;

  @Input('quickMode')
  public quickMode: boolean = false;
  @Input('calendar') calendars: ICalendar[];

  @Input('onAction') onAction: (config: {
    date?: Date;
    view?: CalendarView;
    retrieve: {
      appointments: boolean;
      notes: boolean;
    };
  }) => void;

  @Input('viewDate')
  public viewDate: Date = moment().toDate();

  public title: string = '';
  public selectedDate: Date = new Date();

  constructor(
    public session: SessionService,
    private translate: TranslateService,
  ) {
    super(session);
  }

  public previous() {
    const viewDate = moment(this.viewDate);
    const nextDate = viewDate.subtract(1, this.view);
    this.onAction({
      date: nextDate.toDate(),
      retrieve: { appointments: true, notes: true },
    });
  }

  public next() {
    const viewDate = moment(this.viewDate);
    const nextDate = viewDate.add(1, this.view);
    this.onAction({
      date: nextDate.toDate(),
      retrieve: { appointments: true, notes: true },
    });
  }

  public onDateSelect(date: Date) {
    this.onAction({
      date: date,
      retrieve: { appointments: true, notes: true },
    });
  }

  public goToToday() {
    this.onAction({
      date: moment().toDate(),
      retrieve: { appointments: true, notes: true },
    });
  }

  public calendarTitle() {
    // Configurar locale de moment según idioma actual
    moment.locale(this.translate.currentLang || 'es');

    if (this.view === CalendarView.Month) {
      this.title = moment(this.viewDate).format('MMMM YYYY');
    }
    if (this.view === CalendarView.Day) {
      // Formato: "Martes 26 Enero 2026"
      this.title = moment(this.viewDate).format('dddd DD MMMM YYYY');
    }
    if (this.view === CalendarView.Week) {
      this.title = moment(this.viewDate).format('MMMM YYYY - [S]WW');

      // Suscribirse a cambios de idioma
      this.translate.onLangChange.subscribe(() => {
        this.calendarTitle();
      });
    }
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.calendarTitle();
    this.selectedDate = this.viewDate;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewDate'] || changes['view']) {
      this.calendarTitle();
      this.selectedDate = this.viewDate;
    }
  }
}
